<template>
  <div v-bind:style="{ height: height + 'px' }">
    <div class="content_header">
      <v-toolbar flat color="white mx-2" width="100%">
        <v-toolbar-title style="mar" width="40%">
          <v-row class="pr-3" align-content="center" height="100%">
            <v-col>
              <img
                src="https://appmedia.jp/wp-content/uploads/2018/03/9d963c14bb521f1b7661952369b5a883.png"
                width="40px"
              />おすすめスマホアプリ管理(並び替え)
            </v-col>
          </v-row>
        </v-toolbar-title>
      </v-toolbar>
    </div>

    <v-card class="ma-4 pa-2" color="#fafafa">
      <v-row>
        <v-col cols="11"
          ><a class="pl-6" href="/manage/#/recommendAppli/"
            >◀︎アプリ一覧に戻る</a
          >
        </v-col>
        <v-col cols="1">
          <v-btn color="blue" dark @click="saveItem()">更新</v-btn>
        </v-col>
      </v-row>

    <h3 class="pl-2">★総合ランキング</h3>

      <div class="flex  pa-1">
        <div style="width: 60px"></div>
        <div style="width: 90px;color:red;">現在値</div>
        <div style="width: 50px;color:red;">→</div>
        <div style="width: 60px;color:red;">変更後</div>
        <div style="width: 60px"></div>
        <div style="width: 400px; text-align:left;"></div>
      </div>

      <ul class="sort_list" style="list-style:none;padding:0;">
        <draggable
          v-model="list"
          draggable=".item"
          :options="{ handle: '.drag' }"
          group="items"
        >
          <li
            v-for="item in list"
            :key="item.id"
            class="item pa-1"
            max-width="100"
            style="display:block; width:100%;vertical-align: top;"
          >
            <v-card
              @click="editData(item)"
              dense
              :class="{ disable: item.delete_flg == 1 }"
            >
              <div class="flex drag">
                <div style="width: 60px">
                  <v-icon color="green darken-2">
                    mdi-drag-vertical
                  </v-icon>
                </div>
                <div style="width: 90px">{{ item.sort_all || "未設定" }}</div>
                <div style="width: 50px;">→</div>

                <div style="width: 60px"><span class="no"></span></div>

                <div style="width: 60px">
                  <img
                    :src="item.icon"
                    width="40px"
                    style="vertical-align: middle;margin:4px;"
                    v-if="item.icon"
                  />
                </div>
                <div style="width: 400px; text-align:left;">
                  {{ item.title }}
                </div>
                <div style="width: 100px; text-align:left;">{{ item.category }}</div>
                <pre style="width: 400px; text-align:left;">{{item.remarks}}</pre>
              </div>
            </v-card>
          </li>
        </draggable>
      </ul>
    </v-card>

    <!-- <v-card class="ma-4">
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :items-per-page="50"
        :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
      >
        <template v-slot:item.edit="{ item }">
          <v-icon small color="primary" @click="editItem(item)"
            >fas fa-edit</v-icon
          >
        </template>

        <template v-slot:item.rank="{ item }">
          <div @click="editItem(item)" text v-if="item.rank != ''">
            {{ item.rank }}
          </div>
          <div @click="editItem(item)" text v-else>非表示</div>
        </template>

        <template v-slot:item.content="{ item }">
          <div @click="editItem(item)" text>
            <div @click="editItem(item)" text class="pa-1">
              <img :src="item.icon" width="66px" v-if="item.icon" />
            </div>
          </div>
        </template>

        <template v-slot:item.title="{ item }">
          <div @click="editItem(item)" text>{{ item.title }}</div>
        </template>

        <template v-slot:item.description1="{ item }">
          <div @click="editItem(item)" text>{{ item.description1 }}</div>
        </template>

        <template v-slot:item.delete="{ item }">
          <v-icon small color="red accent-4" @click="deleteItem(item)"
            >fas fa-trash</v-icon
          >
        </template>
      </v-data-table>
    </v-card> -->
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/sortablejs@1.8.4/Sortable.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.23.2/vuedraggable.umd.min.js"></script>

<script>
// Ajax通信ライブラリ
import axios from "axios";
import draggable from "vuedraggable";

export default {
  components: {
    draggable: draggable,
  },

  //===========================
  // dataは基本的に変数の定義とかやるやつっぽい
  //===========================
  data() {
    return {
      tab: null,
      type: "新作アプリ",
      previoustype: "",
      types: ["新作アプリ", "今はじめどき", "人気アプリ"],

      genres: [
        "RPG",
        "アクション",
        "スポーツ",
        "シューティング",
        "ストラテジー",
        "シミュレーション",
        "レーシング",
        "アドベンチャー",
        "カードゲーム",
        "パズル",
        "リズム",
      ],
      //検索用パラメータ
      site_url: "",
      search: "",
      selectedKey: "",
      selectedItem: "",

      loading: false,

      height: 0,
      dialog: false,
      headers: [
        {
          text: "編集",
          align: "center",
          value: "edit",
          sortable: false,
          width: "5%",
        },
        {
          text: "ランク",
          value: "rank",
          width: "5%",
          align: "center",
        },
        {
          text: "アイコン",
          value: "content",
          width: "10%",
          align: "center",
        },
        {
          text: "タイトル",
          value: "title",
          width: "25%",
          align: "left",
        },
        {
          text: "見出し",
          value: "description1",
          width: "30%",
          align: "center",
        },
        {
          text: "カテゴリ",
          value: "category",
          width: "20%",
          align: "center",
        },
        {
          text: "削除",
          align: "center",
          value: "delete",
          sortable: false,
          width: "5%",
        },
      ],

      list: [],
      check_list: [],

      editedIndex: -1,
      // editedItem: {
      //   id: "",
      //   category: "",
      //   title: "",
      //   source: "",
      //   memo: "",
      //   img_count: 0,
      //   imageData1: "",
      //   imageData2: ""
      // },

      showDialog: false,

      //画像拡大用
      imgDialog: false,

      // 入力必須の制約
      // required: value => !!value || "必須項目",
      rules: [(value) => !!value || "入力必須"],

      // 入力項目
      disp_flg: ["表示", "非表示"],
      category: ["今はじめどき", "新作アプリ", "人気アプリ"],

      target_id: "",
      target_title: "",
      target_rank: "",
      target_sort_all: "",

      target_hyouka: "",
      target_genre: "",
      input_image: "",
      target_description1: "",
      target_desc_title: "",
      target_description2: "",
      target_description3: "",
      target_point1: "",
      target_point2: "",
      target_point3: "",
      target_comment_title1: "",
      target_comment1: "",
      target_comment_rank1: "",
      target_comment_title2: "",
      target_comment2: "",
      target_comment_rank2: "",
      target_dl_comment: "",
      target_os: "",
      target_date: "",
      target_dl_vol: "",
      target_icon: "",
      target_category: "",
      target_dl_url: "",
      target_disp_flg: "",
      target_remarks: "",
      target_dl_img: "",
      input_image2: "",
      input_image3: "",
      article_img: "",
      img_items: [],
      img_file: null,
      focus_txt: "",
      focus_txt_ref: "",
    };
  },

  computed: {},

  watch: {},

  //===========================
  // dom生成直前
  //===========================
  created: function() {
    this.dataSearch();
    // this.imgListDisp();
  },

  //===========================
  // dom作成直後
  //===========================
  mounted() {
    // this.imgListDisp();
  },

  //===========================
  // メソッド定義
  //===========================
  methods: {
    //---------------------------
    // データ取得
    //---------------------------
    dataSearch: function() {
      this.previoustype = this.type;

      this.loading = true;
      axios
        .get(process.env.VUE_APP_RECOMMEND_APPLI_ALL_LIST)
        .then((response) => {
          // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);

          console.log(response.data);

          values.forEach((value) => {
            const item = this.itemPush(value);
            if(item.remarks != null){
            item.remarks = item.remarks.trim();

            }
            items.push(item);
          });
          this.list = items;
          this.check_list = Object.assign([], items);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // 更新
    //---------------------------
    saveItem() {
      this.loading = true;

      axios
        .post(process.env.VUE_APP_RECOMMEND_APPLI_ALL_SORT, {
          data: this.list,
        })

        .then((response) => {
          console.log(response.data);
          alert("更新しました！");
          this.showDialog = false;
          this.dataSearch();
        })
        .catch((error) => {
          alert("テキストボックスに空か空白が設定されています\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // 画像一覧取得(記事中画像)
    //---------------------------
    // imgListDisp: function() {
    //   var self = this;
    //   self.loading = true;
    //   console.log(process.env.VUE_APP_RECOMMEND_APPLI_IMG_LIST+"?type=今はじめどき");
    //   axios
    //     .get(process.env.VUE_APP_RECOMMEND_APPLI_IMG_LIST+"?type=今はじめどき")
    //     .then((response) => {
    //       console.log("DDD",response);
    //       self.img_items = Object.values(response.data);
    //     })
    //     .finally(() => {
    //       self.loading = false;
    //     });
    // },

    //---------------------------
    // 受け取った投稿データを配列に追加
    //---------------------------
    itemPush: function(value) {
      var item = {
        id: value.id,
        title: value.title,
        rank: value.rank,
        sort_all: value.sort_all,
        hyouka: value.hyouka,
        genre: value.genre,
        description1: value.description1,
        desc_title: value.desc_title,
        description2: value.description2,
        description3: value.description3,
        point1: value.point1,
        point2: value.point2,
        point3: value.point3,
        comment_title1: value.comment_title1,
        comment1: value.comment1,
        comment_rank1: value.comment_rank1,
        comment_title2: value.comment_title2,
        comment2: value.comment2,
        comment_rank2: value.comment_rank2,
        dl_img: value.dl_img,
        dl_comment: value.dl_comment,
        os: value.os,
        date: value.date,
        dl_vol: value.dl_vol,
        icon: value.icon,
        category: value.category,
        dl_url: value.dl_url,
        remarks: value.remarks,
        disp_flg: value.disp_flg,
        // showDialog: false,
      };
      return item;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },
  },
};
</script>

<style>
ul.sort_list li {
  counter-increment: title;
  text-align: center;
}
ul.sort_list li .no::before {
  content: counter(title);
}
.flex {
  display: flex;
  width: 100%;
  align-items: center;
}
.flex div {
  text-align: center;
}
</style>
